/**
 * Blickwinkel (yaw) der Ego-Ansicht in Radiant.
 *
 * Konvention: 0 blickt nach Norden (sinkendes Map-y, also 'up'), der Winkel
 * waechst gegen den Uhrzeigersinn von oben betrachtet — 0 = Nord, PI/2 = West,
 * PI = Sued, 3*PI/2 = Ost. Daraus ergibt sich der Blickvektor
 * (-sin(yaw), -cos(yaw)) in Map-Koordinaten.
 *
 * Die Draufsicht kennt nur vier Richtungen; `direction` bleibt darum das
 * fuehrende Feld im Protokoll und wird beim Senden aus dem yaw abgeleitet.
 */
export const TAU = Math.PI * 2;
/** Auf 0..2*PI bringen — auch fuer negative und mehrfach umlaufende Winkel. */
export function normalizeYaw(yaw) {
    const wrapped = yaw % TAU;
    return wrapped < 0 ? wrapped + TAU : wrapped;
}
/** Blickvektor in Map-Koordinaten (x nach rechts, y nach unten). */
export function forwardFromYaw(yaw) {
    return { x: -Math.sin(yaw), y: -Math.cos(yaw) };
}
/** Vier-Richtungs-Naeherung fuer die Draufsicht. */
export function directionFromYaw(yaw) {
    const f = forwardFromYaw(yaw);
    if (Math.abs(f.x) > Math.abs(f.y))
        return f.x > 0 ? 'right' : 'left';
    return f.y > 0 ? 'down' : 'up';
}
/** Startblickrichtung aus einem Spawn oder einem 2D-Spieler. */
export function yawFromDirection(direction) {
    switch (direction) {
        case 'up':
            return 0;
        case 'left':
            return Math.PI / 2;
        case 'down':
            return Math.PI;
        case 'right':
            return (3 * Math.PI) / 2;
    }
}
/** Kuerzester Weg von `from` nach `to`, im Bereich -PI..PI. */
export function yawDelta(from, to) {
    return ((to - from + Math.PI) % TAU + TAU) % TAU - Math.PI;
}
/**
 * Interpoliert ueber den kuerzeren Bogen — ohne das dreht ein Avatar beim
 * Sprung von 350 auf 10 Grad einmal komplett im Kreis.
 */
export function lerpYaw(from, to, t) {
    return normalizeYaw(from + yawDelta(from, to) * t);
}
//# sourceMappingURL=angles.js.map